module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\r\n\t<h3>'+
((__t=( title ))==null?'':__t)+
'</h3>\r\n\t<span>'+
((__t=( intro ))==null?'':__t)+
'</span>\r\n\t<div class="totals">\r\n\t\t<span class="selected">Infrazioni selezionate:<b>0</b></span>\r\n\t\t<span class="total">Totale infrazioni:<b>0</b></span>\r\n\t</div>\r\n\t<div class="fields"></div>\r\n</div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/views/sidebar/archive/archiveView.tmpl
 ** module id = 15
 ** module chunks = 0
 **/